import {Fragment} from 'react';
import {KeySolver} from "../../helper/KeySolver";

const Steps: (props: any) => JSX.Element = (props: any) => {

    const {index, children, length, setIndex} = props;

    return (
        <Fragment>
            <div className="relative w-full mt-[42px] mb-[30px] lg:mb-[100px]">
                <div className="absolute w-full left-0 top-0 mt-[-34px] lg:mt-[-42px]">
                    <div className="flex flex-row w-full gap-10">
                        {children.map((item: any, itemIndex: number) =>
                            <Fragment key={KeySolver()} >
                                <button className="flex flex-col gap-2 items-center flex-1 text-[14px] lg:text-[18px]" onClick={() => setIndex(itemIndex)} title={item.properties.title} >
                                    <div className={`${(itemIndex + 1) === index ? 'text-pomegranate-950' : 'text-pomegranate-100'}`} >{itemIndex + 1}/{length}</div>
                                    <div className={`rounded-full ${(itemIndex + 1) === index ? 'bg-pomegranate-950' : 'bg-pomegranate-100'} w-[10px] h-[10px] lg:w-[20px] lg:h-[20px]`} />
                                </button>
                            </Fragment>
                        )}
                    </div>
                </div>
                <div className="w-full h-[1px] bg-gray-200"></div>
            </div>

        </Fragment>
    );
}

export default Steps;
